import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'
const BASEURL_DEV = BASEURL + '/Main/BannerManage'

const manage = {
  BankBusinessList(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/BankBusinessList`,
      params
    })
  },
  Read_Detail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/News/Read_Detail`,
      params
    })
  },
  NewsRead_List(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/News/Read_List`,
      params
    })
  },
  NewsDetail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/News/Detail`,
      params
    })
  },
  NewsUpdateSort(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/News/UpdateSort`,
      data
    })
  },
  NewsDelete(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/News/Delete`,
      data
    })
  },
  NewsEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/News/Edit`,
      data
    })
  },
  NewsPage(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/News/Page`,
      params
    })
  },
  NewsTypeDetail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/NewsType/Detail`,
      params
    })
  },
  NewsTypeUpdateDelete(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/NewsType/UpdateDelete`,
      data
    })
  },
  NewsTypeEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/NewsType/Edit`,
      data
    })
  },
  NewsTypeList(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/NewsType/List`,
      params
    })
  },
  HelpInfoUpdateSort(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/HelpInfo/UpdateSort`,
      data
    })
  },
  HelpInfoDetail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/HelpInfo/Detail`,
      params
    })
  },
  HelpInfoEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/HelpInfo/Edit`,
      data
    })
  },
  HelpInfoBatchDelete(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/HelpInfo/BatchDelete`,
      data
    })
  },
  HelpInfoList(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/HelpInfo/List`,
      params
    })
  },
  HelpClassEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/HelpClass/Edit`,
      data
    })
  },
  HelpClassDetail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/HelpClass/Detail`,
      params
    })
  },
  HelpClassDelet(params) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/HelpClass/Delet`,
      params
    })
  },
  HelpClassList(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/HelpClass/List`,
      params
    })
  },
  GetVierificationCode() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/ServiceRecommendLog/GetVierificationCode`
    })
  },
  SuggestPage(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/InfoCollection/SuggestPage`,
      params
    })
  },
  ApplyPage(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/InfoCollection/ApplyPage`,
      params
    })
  },
  SuggestEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/InfoCollection/SuggestEdit`,
      data
    })
  },
  ApplyEdit(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/InfoCollection/ApplyEdit`,
      data
    })
  },
  PensionAccountsBusiness(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/PensionAccountsBusiness`,
      params
    })
  },
  BankBusinessDetail(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/Detail`,
      params
    })
  },

  ServiceRecommendLogPage(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/ServiceRecommendLog/Page`,
      params
    })
  },
  ServiceRecommendLogAdd(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/ServiceRecommendLog/Add`,
      data
    })
  },
  SocialSecurityCardBusiness() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/SocialSecurityCardBusiness`
    })
  },
  WageCarBusiness() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/WageCarBusiness`
    })
  },
  PersonalLoanBusiness() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/PersonalLoanBusiness`
    })
  },

  CorporateAccountBusiness() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/CorporateAccountBusiness`
    })
  },
  CreditCardBusiness() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/BankBusiness/CreditCardBusiness`
    })
  },
  CooperativeBank(params) {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/Bank/CooperativeBank`,
      params
    })
  },
  BankList() {
    return $http({
      method: 'get',
      url: `${baseUrl.primary}/v1_5/Main/Bank/List`
    })
  },
  BatchAuditTalkDelete(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL}/Main/Talk/BatchAuditTalkDelete`,
      data
    })
  },
  AuditTalkEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL}/Main/Talk/AuditTalkEdit`,
      data
    })
  },
  AuditTalkDelete(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL}/Main/Talk/AuditTalkDelete?id=${id}`
    })
  },
  AuditTalkPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL}/Main/Talk/AuditTalkPage`,
      params
    })
  },
  TalkDetail(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL}/Main/Talk/TalkDetail`,
      params
    })
  },
  TalkPageByFactory(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL}/Main/Talk/TalkPageByFactory`,
      params
    })
  },
  TakePage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL}/Main/Talk/TakePage`,
      params
    })
  },
  MessageOneselfFieldChange(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Message/OneselfFieldChange`,
      data
    })
  },
  MessageRead(data) {
    return $http({
      method: 'post',
      url: `${baseUrl.primary}/v1_5/Main/Message/MessageRead`,
      data
    })
  },
  MessagePage(params) {
    return $http({
      method: 'GET',
      url: `${baseUrl.primary}/v1_5/Main/Message/MessagePage`,
      params
    })
  },
  MessageManageEdit(data) {
    return $http({
      method: 'POST',
      url: `${baseUrl.primary}/v1_5/Main/Message/MessageManageEdit`,
      data
    })
  },
  MessageDetail(params) {
    return $http({
      method: 'GET',
      url: `${baseUrl.primary}/v1_5/Main/Message/MessageDetail`,
      params
    })
  },

  MessageDelete(id) {
    return $http({
      method: 'POST',
      url: `${baseUrl.primary}/v1_5/Main/Message/MessageDelete/${id}`
    })
  },
  OneselfFieldChange(data) {
    return $http({
      method: 'post',
      url: `${BASEURL_DEV}/OneselfFieldChange`,
      data
    })
  },
  BannerPage(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BannerPage`,
      params
    })
  },
  BannerManageEdit(data) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BannerManageEdit`,
      data
    })
  },
  BannerDelete(id) {
    return $http({
      method: 'POST',
      url: `${BASEURL_DEV}/BannerDelete/${id}`
    })
  },
  BannerUpdateSort(params) {
    return $http({
      method: 'GET',
      url: `${BASEURL_DEV}/BannerUpdateSor?list=${params}`
    })
  },

  BannerDetail(id) {
    return $http({
      method: 'Get',
      url: `${BASEURL_DEV}/BannerDetail?id=${id}`
    })
  },

  getManageUserList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Platform/Items`,
      params
    })
  },
  editManageUser(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Platform/Edit`,
      data
    })
  },
  deleteManageUser(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/User/Platform/Del?uid=${id}`
    })
  },
  editSetMeal(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/Product/EditProduct`,
      data
    })
  },
  getSetMealList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Admin/Product/PageList`,
      params
    })
  },
  getSetPointMealList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Point/PointProductPage`,
      params
    })
  },
  editSetPointMeal(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Point//EditProduct`,
      data
    })
  },
  deleteSetMeal(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/Product/Dlete`,
      data
    })
  },
  getPointProductList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Point/PutMarkProductList`
    })
  },
  deleteSetPointMeal(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Point/DeletePointProduct?id=${data}`,
      data
    })
  },
  getVIPUserList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/User/Platform/CompanyList`,
      params
    })
  },
  getSetMealOrderList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Admin/Order/PageList`,
      params
    })
  },
  getResumeOrderList(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Admin/Order/ResumeOrderPage`,
      params
    })
  },
  getWebSiteConfigs() {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/Admin/SiteConfigs/GetSiteConfigs`
    })
  },
  editWebSiteConfigs(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Main/Admin/SiteConfigs/EditSiteConfigs`,
      data
    })
  }
}

export default manage
